import { render, staticRenderFns } from "./store-info.vue?vue&type=template&id=2e8847e6"
import script from "./store-info.vue?vue&type=script&lang=js"
export * from "./store-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports